"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlacementTestDefaults = void 0;
const core_1 = require("@zodios/core");
const zod_1 = require("zod");
const voice_1 = require("../core/voice");
exports.getPlacementTestDefaults = (0, core_1.makeEndpoint)({
    method: "get",
    path: "/app/placement-test",
    alias: "getPlacementTestDefaults",
    parameters: [],
    response: zod_1.z.object({
        voice: voice_1.voiceSchema,
    }),
});
//# sourceMappingURL=getPlacementTestDefaults.js.map